import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import ContentCard from '~/components/ContentCard/ContentCard';
import LoadingSpinner from '~/components/LoadingSpinner/LoadingSpinner';
import { getRelatedContent } from '~/util/getContent';
import logEvent from '~/util/analytics';
import getOr from '~/util/getOr';
import GetTheAppLinks from '~/constants/GetTheAppLinks';
import ContentCardTypes from '~/constants/ContentCardTypes';
import find from 'lodash/find';
import css from './BixbyTeamRiver.scss';

const contentClick = () => {
  logEvent('click', {
    type: 'bixby_content_teams',
    page_type: 'bixby',
    page_name: 'bixby_landing_page',
  });
};

// eslint-disable-next-line react/prefer-stateless-function
class BixbyLandingTeamRiver extends React.Component {
  constructor() {
    super();
    this.state = {
      relatedNews: null,
    };
  }

  componentDidMount() {
    if (this.props.team.resource_uri) {
      this.getDynamicContent();
    }
  }

  async getDynamicContent() {
    const resourceUri = this.props.team.resource_uri;
    const relatedNews = await getRelatedContent(
      resourceUri,
      null,
      null,
      null,
      resourceUri.split('/')[1],
      [ContentCardTypes.THE_SCORE_ARTICLE]
    );
    this.setState({ relatedNews: relatedNews.relatedContentList });
    return this;
  }
  renderContentCard() {
    if (this.state.relatedNews) {
      const relatedArticle = find(this.state.relatedNews, { type: 'theScoreArticleCard' });

      if (relatedArticle) {
        const contentCardStyles = {
          articleStyles: {
            theScoreArticleCardStyles: {
              contentCardImageStyles: {
                contentCardImageStyles: {
                  marginTop: '0px',
                  marginBottom: '-55px',
                },
              },
              contentCardTextStyles: {
                contentCardTextStyles: {
                  fontSize: '10px',
                },
              },
              theScoreContentCardSourceStyles: {
                theScoreContentCardSourceStyles: {
                  height: '7.3px',
                  width: '40px',
                },
              },
              contentCardFooterStyles: {
                contentCardFooterStyles: {
                  fontSize: '7px',
                  minHeight: '15px',
                },
                shareButtonStyles: {
                  shareArrowStyles: {
                    display: 'none',
                  },
                },
              },
            },
          },
        };
        return <ContentCard contentCard={relatedArticle} styleOverrides={contentCardStyles} />;
      }
    }
    return (
      <div className={css.loadingSpinnerContainer}>
        <LoadingSpinner SpinnerType="circle_pulse" />
      </div>
    );
  }
  render() {
    const { team } = this.props;
    const contentBranchLinks = GetTheAppLinks.bixby_teams_content_link;
    return (
      <div className={css.container}>
        <a href={contentBranchLinks} onClick={contentClick}>
          <div className={css.blockLinks} />
        </a>
        <div>
          <div className={css.teamBanner}>
            <div className={css.side}>
              {getOr(team, 'standing.last_ten_games_record', '-')}
              <br />
              <span>Last 10</span>
            </div>
            <div className={css.team}>
              <img alt="" src={team.logos.w72xh72} />
            </div>
            <div className={css.side}>
              {getOr(team, 'standing.streak', '-')}
              <br />
              <span>Streak</span>
            </div>
          </div>
          <div className={css.teamName}>{team.full_name}</div>
          <div className={css.teamRecord}>
            {getOr(team, 'standing.short_record', '-')},&nbsp;
            {getOr(team, 'standing.formatted_rank', '-')}
          </div>
        </div>
        <div className={css.cardsContainer}>
          <div className={css.card}>{this.renderContentCard()}</div>
        </div>
      </div>
    );
  }
}

BixbyLandingTeamRiver.propTypes = {
  team: PropTypes.object.isRequired,
};

BixbyLandingTeamRiver.displayName = 'BixbyTeamRiver';

export default StyledComponent(BixbyLandingTeamRiver, [css]);
